export default __webpack_public_path__ + "5a7afe296ab315b1b83f1cd16e262010.png";